var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    stroke: "#FF0606",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42534 6L7.91404 7.4887C7.96951 7.5453 8.0004 7.6215 8 7.70074C7.9996 7.77999 7.96794 7.85587 7.9119 7.9119C7.85587 7.96794 7.77999 7.9996 7.70074 8C7.6215 8.0004 7.5453 7.96951 7.4887 7.91404L6 6.42534L4.5113 7.91404C4.4547 7.96951 4.3785 8.0004 4.29926 8C4.22001 7.9996 4.14413 7.96794 4.0881 7.9119C4.03206 7.85587 4.0004 7.77999 4 7.70074C3.9996 7.6215 4.03049 7.5453 4.08596 7.4887L5.57466 6L4.08596 4.5113C4.03049 4.4547 3.9996 4.3785 4 4.29926C4.0004 4.22001 4.03206 4.14413 4.0881 4.0881C4.14413 4.03206 4.22001 4.0004 4.29926 4C4.3785 3.9996 4.4547 4.03049 4.5113 4.08596L6 5.57466L7.4887 4.08596C7.5453 4.03049 7.6215 3.9996 7.70074 4C7.77999 4.0004 7.85587 4.03206 7.9119 4.0881C7.96794 4.14413 7.9996 4.22001 8 4.29926C8.0004 4.3785 7.96951 4.4547 7.91404 4.5113L6.42534 6Z",
    fill: "#FF0606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRed);
export default __webpack_public_path__ + "static/media/close-icon-red.a2b05c76469714dd632977ed157aba1a.svg";
export { ForwardRef as ReactComponent };